<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title">CONTENTS</p>
<p class="toc-entry"><a href="#/xhtml/part01">PART ONE</a></p>
<p class="toc-entry1"><a href="#/xhtml/chapter001"><i>One • A Long Friday</i></a></p>
<p class="toc-entry1"><a href="#/xhtml/chapter002"><i>Two • First Kaddish</i></a></p>
<p class="toc-entry"><a href="#/xhtml/part02">PART TWO</a></p>
<p class="toc-entry1"><a href="#/xhtml/chapter003"><i>Three • Before Memory</i></a></p>
<p class="toc-entry1"><span href="#/xhtml/chapter004" title="Link target outside of Sample"><i>Four • The Protective Circle</i></span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter005" title="Link target outside of Sample"><i>Five • Growing Up and Away</i></span></p>
<p class="toc-entry"><span href="#/xhtml/part03" title="Link target outside of Sample">PART THREE</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter006" title="Link target outside of Sample"><i>Six • Adolescence</i></span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter007" title="Link target outside of Sample"><i>Seven • Perspective</i></span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter008" title="Link target outside of Sample"><i>Eight • A Soldier in His Army</i></span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter009" title="Link target outside of Sample"><i>Nine • My Father, His Daughter</i></span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter010" title="Link target outside of Sample"><i>Ten • The Six-Day War</i></span></p>
<p class="toc-entry"><span href="#/xhtml/part04" title="Link target outside of Sample">PART FOUR</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter011" title="Link target outside of Sample"><i>Eleven • Between Two Wars</i></span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter012" title="Link target outside of Sample"><i>Twelve • 1973–1977</i></span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter013" title="Link target outside of Sample"><i>Thirteen • Peace</i></span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter014" title="Link target outside of Sample"><i>Fourteen • Two Years in My Father’s Death</i></span></p>
<p class="toc-entry"><span href="#/xhtml/part05" title="Link target outside of Sample">PART FIVE</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter015" title="Link target outside of Sample"><i>Fifteen • Shiva</i></span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter016" title="Link target outside of Sample"><i>Sixteen • Last Kaddish</i></span></p>
<p class="toc-entry2"><span href="#/xhtml/endmatter01" title="Link target outside of Sample"><i>Epilogue</i></span></p>
<p class="toc-entry2"><span href="#/xhtml/endmatter03" title="Link target outside of Sample">Image Gallery</span></p>
<p class="toc-entry1"><span href="#/xhtml/endmatter02" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?416bc8e2